import { useEffect, useState } from "react";
import { Progress } from "@/components/ui/progress";
import { apiBaseURL } from "@/initializers/axios-client";

interface StaticMapProps {
  username?: string;
  city?: string;
}

export const PublicStaticMap = ({ username, city }: StaticMapProps) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [iframeError, setIframeError] = useState(false);
  const [progress, setProgress] = useState(0);

  const mapUrl = `${apiBaseURL}/public/${username}/${city}/map.html`;

  useEffect(() => {
    if (!iframeLoaded && !iframeError) {
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 90) return prev;
          return prev + 20;
        });
      }, 20);

      return () => clearInterval(interval);
    }
  }, [iframeLoaded, iframeError]);

  useEffect(() => {
    if (iframeLoaded) {
      setProgress(100);
    }
  }, [iframeLoaded]);

  return (
    <div className="relative h-screen w-full">
      <iframe
        src={mapUrl}
        className={`h-full w-full border-0 transition-opacity duration-300 ${
          iframeLoaded ? "opacity-100" : "opacity-0"
        }`}
        onLoad={() => setIframeLoaded(true)}
        onError={() => setIframeError(true)}
        title="Interactive Map"
        allow="geolocation"
      />

      {!iframeLoaded && !iframeError && (
        <div className="absolute inset-0 z-10 flex h-screen w-full items-center justify-center bg-white bg-opacity-90">
          <div className="w-[110px] min-w-[110px]">
            <p className="mb-2 text-center text-sm">Loading...</p>
            <Progress
              className="h-1 w-full overflow-hidden bg-secondary"
              value={progress}
            >
              <div
                className="h-full w-full bg-primary transition-all duration-1000 ease-linear"
                style={{
                  transform: `translateX(-${100 - progress}%)`,
                }}
              />
            </Progress>
          </div>
        </div>
      )}
    </div>
  );
};
